module.exports = __webpack_public_path__ + "static/media/designerCut-03.06c8bda6.png";